/*
 * Finds the index in an array that contains an attribute and matching value to the ones provided as parameters
 */

export const findIndexByAttributeValue = (array: Array<{}>, attr: string, value: string) => {
    for (let counter = 0; counter < array.length; counter += 1) {
        if (array[counter][attr] === value) {
            return counter;
        }
    }
};



// WEBPACK FOOTER //
// ./src/helpers/arrayUtils.ts